import React from 'react';
import { Logo } from './style';

export default (width, height) => <Logo w={width} h={height} />;
